/* MASX - Filtro de Talla en linea en movil (coleccion y busqueda).
   En movil el tema muestra los filtros como cajon lateral. Este script mueve solo
   el bloque "Talla" desde #CollectionSidebar hasta justo debajo de la barra
   "Filtrar / Ordenar por" y encima de la grilla de productos.
   El resto de los filtros (Categoria, Precio, Disponibilidad, Colores,
   Complementos) siguen dentro del cajon del boton Filtrar.
   Se reaplica despues de cada filtrado porque el tema rehace ese HTML. */
(function () {
  'use strict';

  var box = null;
  var busy = false;
  var timer = null;

  var CSS = [
    '#masx-inline-filters{',
    'display:block!important;position:static!important;top:auto!important;left:auto!important;',
    'right:auto!important;bottom:auto!important;transform:none!important;visibility:visible!important;',
    'opacity:1!important;width:100%!important;max-width:100%!important;height:auto!important;',
    'max-height:none!important;min-height:0!important;overflow:visible!important;z-index:auto!important;',
    'box-shadow:none!important;background:transparent!important;padding:0!important;',
    'margin:0 0 20px!important;border:1px solid var(--border-color-base,#e5e5e5);',
    'border-radius:8px;transition:none!important}',
    '#masx-inline-filters .filter-item{padding-left:15px!important;padding-right:15px!important}',
    '#masx-inline-filters collapsible-block{display:block;border:0!important;padding-bottom:0!important}',
    '#masx-inline-filters .collapsible-heading{padding-top:14px!important;padding-bottom:14px!important}',
    '#masx-inline-filters .filter-content{max-height:210px;overflow-y:auto;padding-bottom:15px!important}',
    '#masx-inline-filters .filter-content>ul{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px}',
    '#masx-inline-filters .filter-content>ul>li{margin:0!important;padding:0!important}'
  ].join('');

  function injectCss() {
    if (document.getElementById('masx-inline-filters-css')) return;
    var st = document.createElement('style');
    st.id = 'masx-inline-filters-css';
    st.textContent = CSS;
    (document.head || document.documentElement).appendChild(st);
  }

  /* Movil = el ancho cae bajo el breakpoint del tema, o el tema ya dejo la barra
     de filtros como cajon flotante (position:fixed). Con las dos condiciones el
     script funciona aunque el CSS del tema cargue despues del script. */
  function isMobileLayout(sidebar) {
    try {
      if (window.matchMedia && window.matchMedia('(max-width: 1024px)').matches) return true;
      return window.getComputedStyle(sidebar).position === 'fixed';
    } catch (e) {
      return false;
    }
  }

  function labelOf(item) {
    var h = item.querySelector('.collapsible-heading');
    return h ? h.textContent.replace(/\s+/g, ' ').trim().toLowerCase() : '';
  }

  function findItem(scope, word) {
    var items = scope.querySelectorAll('.filter-item');
    for (var i = 0; i < items.length; i++) {
      if (labelOf(items[i]).indexOf(word) === 0) return items[i];
    }
    return null;
  }

  function setOpen(item, open) {
    var cb = item.querySelector('collapsible-block');
    if (!cb) return;
    if (open) cb.classList.add('active');
    else cb.classList.remove('active');
  }

  function takeOut(item, target) {
    var mark = document.createComment('masx-slot');
    if (item.parentNode) item.parentNode.insertBefore(mark, item);
    item.masxMark = mark;
    target.appendChild(item);
  }

  function putBack() {
    if (!box) return;
    var kids = Array.prototype.slice.call(box.children);
    for (var i = 0; i < kids.length; i++) {
      var m = kids[i].masxMark;
      if (m && m.parentNode) {
        m.parentNode.insertBefore(kids[i], m);
        m.parentNode.removeChild(m);
      }
    }
    if (box.parentNode) box.parentNode.removeChild(box);
    box = null;
  }

  function mount() {
    if (busy) return;

    var grid = document.getElementById('productgridcontainer');
    var sidebar = document.getElementById('CollectionSidebar');
    if (!grid || !sidebar) return;

    if (!isMobileLayout(sidebar)) {
      putBack();
      return;
    }

    var blocks = sidebar.querySelector('.filter-blocks') || sidebar;
    var talla = findItem(blocks, 'talla');
    if (!talla) return;

    busy = true;
    try {
      if (!box || !document.body.contains(box)) {
        box = document.createElement('div');
        box.id = 'masx-inline-filters';
        box.className = 'collection-filter';
      }

      if (!grid.contains(box)) {
        /* La barra Filtrar/Ordenar y la grilla comparten contenedor en movil,
           asi que el bloque va inmediatamente despues de la barra. */
        var toolbar = grid.querySelector('.toolbar-products');
        if (toolbar && toolbar.parentNode) {
          toolbar.parentNode.insertBefore(box, toolbar.nextSibling);
        } else {
          grid.insertBefore(box, grid.firstChild);
        }
      }

      while (box.firstChild) box.removeChild(box.firstChild);
      takeOut(talla, box);
      setOpen(talla, true);
    } catch (e) {
      /* nunca romper la pagina por este ajuste */
    } finally {
      busy = false;
    }
  }

  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(mount, 30);
  }

  function start() {
    injectCss();
    mount();

    if (window.MutationObserver) {
      var obs = new MutationObserver(function () {
        if (!busy) schedule();
      });
      obs.observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('resize', schedule, false);
    window.addEventListener('orientationchange', schedule, false);
    window.addEventListener('popstate', schedule, false);
    window.addEventListener('load', schedule, false);

    /* Reintentos: el CSS del tema se carga en diferido, asi que la primera
       comprobacion puede ocurrir antes de que exista el layout definitivo. */
    var delays = [200, 600, 1500, 3000];
    for (var i = 0; i < delays.length; i++) {
      setTimeout(mount, delays[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, false);
  } else {
    start();
  }
})();